export const sharedContentTopics = [
  "Programlama",
  "Kuvvet",
  "Hipertrofi",
  "Squat",
  "Bench Press",
  "Deadlift",
  "Teknik",
  "RPE ve Otoregülasyon",
  "Beslenme",
  "Vücut Kompozisyonu",
  "Toparlanma",
  "Yarışma",
  "Ekipman",
] as const;

export type SharedContentTopic = (typeof sharedContentTopics)[number];
